export const routes = {
  register: { key: 'Register', name: 'register' },
  registerWithPhone: { key: 'RegisterWithPhone', name: 'register-with-phone' },
  verifyPhone: { key: 'VerifyPhone', name: 'verify-phone' },
  login: { key: 'Login', name: 'login' },
  pages: { key: 'Pages', name: 'pages' },
  dashboard: { key: 'Dashboard', name: 'dashboard' },
  profile: { key: 'Profile', name: 'profile' },
  report: { key: 'Report', name: 'report' },
  link: { key: 'Link', name: 'links' },
  shop: { key: 'Shop', name: 'shop' },
  gallery: { key: 'Gallery', name: 'gallery' },
  resume: { key: 'Resume', name: 'resume' },
  theme: { key: 'Theme', name: 'theme' },
  order: { key: 'Order', name: 'order' },
  previewProfile: { key: 'PreviewProfile', name: 'profile' },
  previewLink: { key: 'PreviewLink', name: 'links' },
  previewShop: { key: 'PreviewShop', name: 'shop' },
  previewGallery: { key: 'PreviewGallery', name: 'gallery' },
  previewResume: { key: 'PreviewResume', name: 'resume' },
  signOut: { key: 'SignOut', name: 'signout' },
  notFound: { key: '404', name: '*' },
  preview: { key: 'Preview', name: '/:pageName' },
  previewPostDetail: { key: 'PreviewPostDetail', name: '/:pageName/:shortLink' },
  productBasket: { key: 'ProductBasket', name: '/:pageName/basket' },
  adminReports: { key: 'AdminReports', name: 'reports' },
  adminUsers: { key: 'AdminUsers', name: 'users' },
  pageLanguageSetup: { key: 'PageLanguageSetup', name: 'page-language-setup' },
  pageNameSetup: { key: 'PageNameSetup', name: 'page-name-setup' },
  pageFullnameSetup: { key: 'PageFullnameSetup', name: 'page-fullname-setup' },
  pageAvatarSetup: { key: 'PageAvatarSetup', name: 'page-avatar-setup' },
  pageTagsSetup: { key: 'PageTagsSetup', name: 'page-tags-setup' },
};
